export function getStoreData(objGetter, defaultValue = undefined) {
    try {
        return objGetter();
    } catch(e)
    {
        return defaultValue;
    }
}
